const selectors = {
  appWrapper: '.dpo-container',
  form: '.product-custom-quote form',
  row: '.admin__field-option',
  rowText: '.admin__field-label',
  quoteError: '.quote-error__message',
  productPrice: '.product__price',
  productPriceCustom: '.product__price--custom',
  quoteErrorHiddenClass: 'quote-error__message--hidden',
  hiddenClass: 'visually-hidden',
};

/**
 * Show error message
 */
function showErrorMessage() {
  const quoteMessage = document.querySelector(selectors.quoteError);
  quoteMessage.classList.remove(selectors.quoteErrorHiddenClass);
  setTimeout(() => {
    quoteMessage.classList.add(selectors.quoteErrorHiddenClass);
  }, 3000);
}

/**
 * Add element to form
 *
 * @param {HTMLElement} form form element
 * @param {string} selectedOptions selected variants message
 */
function addOptionsToForm(form, selectedOptions) {
  const textarea = document.createElement('textarea');
  textarea.classList.add(selectors.hiddenClass);
  textarea.setAttribute('form', form.id);
  textarea.setAttribute('name', `contact[Options]`);
  textarea.value = `${selectedOptions}`;
  form.appendChild(textarea);
}

/**
 * Get selected variants and combine into string
 *
 * @returns {string|null} selected variants
 */
function getSelectedOptions() {
  const sections = document.querySelectorAll(`${selectors.appWrapper} li.fields`);
  if (!sections || sections.length === 0) return null;
  let hasMissingValues = false;

  const selectedOptions = Array.from(sections).reduce((accumulator, section) => {
    const heading = section.querySelector('label')?.textContent.replace('*', '');
    let isRequiredValueFilled = !section.querySelector('label')?.classList.contains('required');
    const rows = section.querySelectorAll(selectors.row);
    if (!rows || rows.length === 0) return accumulator;

    const options = Array.from(rows).reduce((acc, row) => {
      const input = row.querySelector('input');
      if (!input.checked) return acc;
      isRequiredValueFilled = true;
      const name = row.querySelector(`${selectors.rowText} span`)?.textContent || '';
      const price = row.querySelector(`${selectors.rowText} .price-notice`)?.textContent || '0 zł';
      return `${acc}${name}: ${price}\n`;
    }, '');

    if (!isRequiredValueFilled) hasMissingValues = true;
    return `${accumulator}${heading}\n${options}\n`;
  }, '');

  return hasMissingValues ? null : selectedOptions;
}

/**
 * Validate selected variants and send form
 */
function handleForm() {
  const form = document.querySelector(selectors.form);
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const selectedOptions = getSelectedOptions();
    if (!selectedOptions) {
      showErrorMessage();
      return;
    }
    addOptionsToForm(form, selectedOptions);
    form.submit();
  });
}

/**
 * Wait for user customization, then hide price range and show calculated price
 */
function handlePrice() {
  let counter = 0;
  const interval = setInterval(() => {
    const formInputs = document.querySelectorAll(`${selectors.appWrapper} input`);
    if (counter === 20) clearInterval(interval);
    if (!formInputs || formInputs.length === 0) {
      counter += 1;
    } else {
      formInputs.forEach((input) => {
        input.addEventListener('click', () => {
          document.querySelector(selectors.productPriceCustom).classList.add(selectors.hiddenClass);
          document.querySelector(selectors.productPrice).classList.remove(selectors.hiddenClass);
          clearInterval(interval);
        });
      });
    }
  }, 500);
}

/**
 * Init
 */
function init() {
  handlePrice();
  handleForm();
}

init();
